module.exports = __webpack_public_path__ + "static/img/M-7.af0cb14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgzgk/M-7.png
// module id = blnH
// module chunks = 0